import { Div, TooltipWrapper, lightTheme } from '@vgrubs/components';
import { LocationAgent } from 'components/src/types/api/location.types';

const AVATAR_COLORS = [
  '#E61E29',
  '#F5A623',
  '#7B61FF',
  '#34C759',
  '#0A84FF',
  '#FF375F',
];

const AVATAR_MAX = 5;
const AVATAR_SIZE = '32px';

const getInitials = (name?: string) =>
  (name || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase() || '?';

// Overlapping circles with the agents' initials; "+N" for the overflow.
// Each agent has a name tooltip and links to its agent details page.
export const AgentAvatars = ({
  agents,
  onShowAll,
}: {
  agents: LocationAgent[];
  onShowAll: () => void;
}) => {
  const shown = agents.slice(0, AVATAR_MAX);
  const overflow = agents.length - shown.length;

  const circleProps = {
    $flex: true,
    $center: true,
    $flexNone: true,
    $width: AVATAR_SIZE,
    $height: AVATAR_SIZE,
    $widthSM: AVATAR_SIZE,
    $heightSM: AVATAR_SIZE,
    $borderRadius: '50%',
    $color: lightTheme.white,
  } as const;

  const circleStyle = {
    border: `2px solid ${lightTheme.white}`,
    fontWeight: 600,
    fontSize: '11px',
  } as const;

  return (
    <Div $flex $alignCenter>
      {shown.map((agent, i) => (
        <TooltipWrapper
          key={agent.agentId}
          tooltip={agent.name}
          onClick={() => window.open(`/users/agent/${agent.userId}`, '_blank')}
          style={{
            marginLeft: i === 0 ? 0 : '-10px',
            position: 'relative',
            zIndex: shown.length - i,
            cursor: 'pointer',
          }}
        >
          <Div
            {...circleProps}
            $background={AVATAR_COLORS[i % AVATAR_COLORS.length]}
            style={circleStyle}
          >
            {getInitials(agent.name)}
          </Div>
        </TooltipWrapper>
      ))}
      {/* Always-present trailing circle to open the agents modal: "+N" when
          there are more agents than shown, otherwise a "more" affordance. */}
      <TooltipWrapper
        tooltip="View Agents"
        onClick={onShowAll}
        style={{
          marginLeft: shown.length > 0 ? '-10px' : 0,
          position: 'relative',
          zIndex: 0,
          cursor: 'pointer',
        }}
      >
        <Div
          {...circleProps}
          $background={lightTheme.lightGray}
          style={circleStyle}
        >
          {overflow > 0 ? `+${overflow}` : '⋯'}
        </Div>
      </TooltipWrapper>
    </Div>
  );
};
